import React from 'react';
import { Box } from '@mui/material';
import { WarningAmberRounded } from '@mui/icons-material';

/** helperText for password fields while Caps Lock is on. */
export const CapsLockHelperText: React.FC = () => (
  <Box
    component="span"
    role="status"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.5,
      color: 'warning.main',
      fontWeight: 500,
    }}
  >
    <WarningAmberRounded sx={{ fontSize: 16 }} />
    Bloq Mayús está activado.
  </Box>
);

export default CapsLockHelperText;
